<template>
  <transition-group name="slide-in" class="options-wrapper">
    <div class="option"
    v-for="(option,index) in getOptions"
    :key="'opt'+index"
    :style="{'--index': index}"     
     :class="{ active : active_el == index, ['color_' + option.title]: true }"
    @click="selectOption(option);activate(index);">
      <img v-if="option.img" :src="require('../assets/images/'+option.img)" alt="">
      <div class="title">{{ option.title }}</div>
    </div>
    
  </transition-group>
</template>

<script>
  export default {
    props: [
      'activeConfigStep',
      'configuration'
    ],
    data: () => {
      return {
        showOptions: false,
        active_el:-1
      }
    },
    computed: {
      getOptions() {
        return this.showOptions === true ?
          this.configuration[this.activeConfigStep].options : [];
      }
    },
    methods: {
    activate:function(el){
        this.active_el = el;
    },
      selectOption(option) {
        this.showOptions = false;

        if(this.activeConfigStep +1 < this.configuration.length) {
          setTimeout(() => {
            this.$emit('chooseOption', option);
            this.showOptions = true;
          }, 500);
        }
      }
    },
    mounted() {
      this.showOptions = true;
    }
  }
</script>

<style lang="scss" scoped>
  .options-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;

    padding: 0px 20px;
  }

  .option {
    display: inline-block;
    padding: 5px;
    /* border-top: 1px solid #ddd; */
    cursor: pointer;
    border: 1px solid black;

    img {
      float: left;
      width: 50px;
      height: auto;
      visibility: hidden;
    }

    .title { float: left; padding-top: 8px; display: none; }
    .price { float: right; padding-top: 8px; }
  }

  .color_žlutá {background: #FEE000;} /* zluta */
  .color_oranžová {background: #FF8521;} /* oranzova */
  .color_červená {background: #D4182D;} /* cervena */
  .color_reflexní.červená {background: #F02B0D;} /* reflexni cervena */
  .color_modrá {background: #1400f3;} /* modra */
  .color_temně.modrá {background: #061B50;} /* temne modra */
  .color_černá {background: #000000;} /* cerna */
  .color_purpurová {background: #F30A5F;} /* purpurova */
  .color_šedá {background: #3C3C3C;} /* seda */
  .color_viridian.zelená {background: #3EB9AA;} /* virdian zelena */
  .color_reflexní.žlutá {background: #F4E234;} /* reflexni zluta */
  .color_sharp.zelená {background: #A0C76E;} /* sharp zelena */

  .slide-in-enter-active {
    transition: opacity .2s linear;
  }

  .slide-in-leave-active {
    transition: opacity .5s linear;
  }

  .slide-in-enter {
    opacity: 1;
  }

  .slide-in-leave-to {
    opacity: 1;
  }
</style>
